import { CIDService } from "./../../../../services/common/cid.service";
import { StaticValueService } from "src/app/services/http/business/staticValue/static-value.service";
import { ContractEntryComponent } from "./../contract-entry/contract-entry.component";
import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngstack/translate";
import {
  MatDialogRef,
  MatDialog,
  MatSelectChange
} from "@angular/material";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";

//import { SoundEnum } from "src/app/enums/sound.enum";
import { IContractInfo } from "src/app/interfaces/contractInfo";
//import { SnackBarService } from "src/app/services/common/snackBar.service";
import { ContractService } from "src/app/services/http/business/contract/contract.service";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { ICompany } from "src/app/interfaces/company";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { ErrorsService } from "src/app/services/common/errors.service";

@Component({
  selector: "app-sms-varification-entry",
  templateUrl: "./sms-varification-entry.component.html",
  styleUrls: ["./sms-varification-entry.component.css"]
})
export class SmsVarificationEntryComponent implements OnInit {
  form: FormGroup;
  isOwner: boolean;
  companyList: ICompany;
  showReciveCodeLink = true;
  contractTypeList: IContractInfo;
  errors = new Array();
  errObject: any;
  param: any;

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private cidService: CIDService,
    //private snackBar: SnackBarService,
    public translate: TranslateService,
    private holdingService: HoldingService,
    private companyService: CompanyService,
    private contractService: ContractService,
    private errorService: ErrorsService,
    private staticvalueService: StaticValueService,
    private dialogRef: MatDialogRef<SmsVarificationEntryComponent>
  ) { }

  ngOnInit() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner) {
        this.getCompanyList();
      }
    });
    this.createForm();
    this.getContractType();
  }

  createForm() {
    this.form = this.fb.group({
      NationalCode: [
        null,
        Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]*$"),
          Validators.minLength(10),
          Validators.maxLength(12)
        ])
      ],
      xActivateCode: [null],
      ContractTypeId: [null, Validators.compose([Validators.required])],
      Company: [
        this.cidService.getCID(),
        Validators.compose([Validators.required])
      ]
    });
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  setCompanyCode(e: MatSelectChange) {
    this.cidService.setCID(e.value);
  }

  submitForm(form: IContractInfo) {
    this.errors = new Array();
    this.contractService.getContractInfo(form).subscribe(
      () => {
        this.contractService.getContractInfo(form).subscribe(
          res => {
            this.dialogRef.close();
            this.dialog
              .open(ContractEntryComponent, {
                width: "90%",
                height: "90%",
                data: res
              })
              .afterClosed()
              .subscribe(() => {
                this.contractService.fire();
              });
          },
          err => {
            this.errObject = this.errorService.getError(err);
            this.param = this.errorService.objectError(this.errObject);
            this.errors = this.errorService.returnError(err);
          }
        );
      },
      err => {
        this.errObject = this.errorService.getError(err);
        this.param = this.errorService.objectError(this.errObject);
        this.errors = this.errorService.returnError(err);
      }
    );
  }

  onNoclick() {
    this.dialogRef.close();
  }

  getContractType() {
    this.staticvalueService.ContractType().subscribe(res => {
      this.contractTypeList = res;
    });
  }
}
